import React, { Component } from 'react';
import cx from 'classnames';
import onEnterPressed from '@shootsta/on-enter-pressed';

import Text from '../../../../Text/Text';
import Icon from '../../../../Icon';
import { ACTION_BTN, RED_COLOR } from '../styles/actionItem';
import '../styles/_action-item.scss';

class ActionItem extends Component {
  onClick = (event) => {
    const { action, hidePopover } = this.props;

    event.preventDefault();
    event.stopPropagation();

    action(event);

    if (!hidePopover) {return;}

    hidePopover();
  };

  render() {
    const {
      label,
      isRed,
      separator,
      children,
      className = '',
      hasSubmenu,
      prefixIconText
    } = this.props;

    if (separator) {
      return <hr className="action-item__separator" />;
    }

    return (
      <div
        className={cx(`action-item__btn ${className}`, ACTION_BTN)}
        onClick={this.onClick}
        tabIndex={0}
        role="button"
        onKeyPress={onEnterPressed({ onClick: this.onClick })}>

        {
        typeof label === 'string' ?

        <>
                  <Text
            noMargin
            className={cx({ [RED_COLOR]: isRed })}
            prefixIcon={prefixIconText}>

                    {label}
                  </Text>
                  {hasSubmenu &&
          <Icon
            className="submenu-icon"
            name="arrowright"
            color="denim"
            size={10} />}


                </> :

        label}

        {children}
      </div>);

  }
}

export default ActionItem;